module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO MARQUESBRANDING_DESTAQUES-c005891ec68db52cfe4b9be7d8382337.png";